(function () {
    'use strict';

    function programPage() {      

        const DOMESTIC = 'domestic';
        const INTERNATIONAL = 'international';

        const intOnly = document.querySelector('[data-intonly="True"]');
        const intNodes = document.querySelectorAll('[data-international]');
        const domNodes = document.querySelectorAll('[data-domestic]');

        this.setViewType = type => {
            if (type === DOMESTIC) {
                intNodes.forEach(n => n.classList.add('d-none'));
                domNodes.forEach(n => n.classList.remove('d-none'));
            } else if (type === INTERNATIONAL) {
                intNodes.forEach(n => n.classList.remove('d-none'));
                domNodes.forEach(n => n.classList.add('d-none'));
            }
        }

        this.setViewType(intOnly ? INTERNATIONAL : DOMESTIC);      
    }

    angular.module('Uscapp').controller('programPageCtrl', programPage);
}());